import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

import { handleGetDownloadZipRemessa } from "@/domain/use-cases/remessas/get-download-zip-remessa";

// toast helper
const notifySuccess = (message: string) =>
  toast(message, {
    type: "success",
    position: "top-center",
  });

const notifyError = (message: string) =>
  toast(message, {
    type: "error",
    position: "top-center",
  });

export function useDownloadRemessaZip() {
  const { token: accessToken } = useStoreZustandUserAuth();

  const mutation = useMutation({
    mutationFn: async (payload: { remessa_id: number; numero_remessa: number }) => {
      if (!accessToken) throw new Error("Token de acesso não encontrado");
      await handleGetDownloadZipRemessa(accessToken, payload.remessa_id, payload.numero_remessa);
    },
    onSuccess: () => {
      notifySuccess("O arquivo ZIP está sendo baixado...");
    },
    onError: (error: any) => {
      notifyError(error?.response?.data?.message ?? "Falha ao gerar o arquivo ZIP.");
    },
  });

  return {
    downloadZip: mutation.mutate,
    isLoading: mutation.isPending,
    isError: mutation.isError,
  };
}
